import * as React from "react";

import { Alignment, Classes, H3, H5, InputGroup, Navbar, Switch, Tab, TabId, Tabs,Card,Button } from "@blueprintjs/core";
import { Example, handleBooleanChange, IExampleProps } from "@blueprintjs/docs-theme";
import CardDocuments from './CardDocuments.tsx';

export interface ITabsExampleState {
    activePanelOnly: boolean;
    animate: boolean;
    navbarTabId: TabId;
    vertical: boolean;
    matiere_id:string;
    codeenseignant:string;
}

export  class TabsEnseignants extends React.PureComponent<IExampleProps, ITabsExampleState> {
    myRef=null
    constructor(props) {
        super(props);
        // Declaring refs
        this.myRef = React.createRef();
      }  
    
    public state: ITabsExampleState = {
        activePanelOnly: false,
        animate: true,
        navbarTabId: "",
        vertical: true,
        matiere_id:"0",
        codeenseignant: ""
    };
    
    private toggleActiveOnly = handleBooleanChange(activePanelOnly => this.setState({ activePanelOnly }));

    private toggleAnimate = handleBooleanChange(animate => this.setState({ animate }));

    private toggleVertical = handleBooleanChange(vertical => this.setState({ vertical }));
    private handleNavbarTabChange = (navbarTabId: TabId) => this.setState({ navbarTabId });

    handleInput = event => {
        this.setState({ codeenseignant: event.target.value });
      };
    sendCodeEnseignant=function(ev)
    {
        alert(this.state.codeenseignant);
        this.myRef.current.value="";
    }

    public render() {
       /* const options = (
            <>
                <H5>Props</H5>
                <Switch checked={this.state.animate} label="Animate indicator" onChange={this.toggleAnimate} />
                <Switch checked={this.state.vertical} label="Use vertical tabs" onChange={this.toggleVertical} />
                <Switch
                    checked={this.state.activePanelOnly}
                    label="Render active tab panel only"
                    onChange={this.toggleActiveOnly}
                />
            </>
        );*/
        //const {[...this.props],matiere_id}=this.props
        //{/* <div style={{backgroundColor:"#fff",height:"100%"}} {...this.props}>*/}
        return (
            <div style={{display:this.props.isnotenseignant,flexDirection:"column", position:'absolute', width:'calc( 100% - 20px)',height:'100%',padding:'10px',backgroundColor:"rgba(245,245,245,0.9", boxShadow :' 0 0 0 1px rgb(16 22 26 / 10%), 0 1px 1px rgb(16 22 26 / 20%), 0 2px 6px rgb(16 22 26 / 20%)'}}>
                
                <Card style={{width:320,margin:10}}>Ajouter un Enseignant<input ref={this.myRef} style={{padding:"8px"}}type="text" placeholder="Code donné par l'enseignant" onChange={(ev)=>{this.handleInput(ev)}}/><Button onClick={()=>{this.sendCodeEnseignant()}} style={{marginLeft:"10px"}}>Ajouter</Button></Card>
                
                {/* uncontrolled mode & each Tab has a panel: */}
                <Tabs
                    style={{width:'100%', backgroundColor: "#fff",margin: "10px", padding:"10px"}}
                    animate={this.state.animate}
                    id="TabsExample"
                    key={this.state.vertical ? "vertical" : "horizontal"}
                    renderActiveTabPanelOnly={this.state.activePanelOnly}
                    vertical={this.state.vertical}
                    onChange={this.handleNavbarTabChange}
                    large='true'
                >
                    <Tab style={{width:'100%'}} id="5005" title="Mr Xerces" panel={<MatierePanel style={{width:'100%'}}  matiere_id="1" />} />
                    <Tab id="8008" title="Mr Paoli" panel={<MatierePanel matiere_id="2" />} />
                    <Tab id="9009" title="Mme Martin" panel={<MatierePanel matiere_id="3"  />} />
                    <Tab id="4004" title="Mlle Lumens" panel={<MatierePanel matiere_id="4"  />} />
                    <Tabs.Expander />
                    {/*<InputGroup className={Classes.FILL} type="text" placeholder="Search..." />*/}
                </Tabs>
            </div>
        );
    }

    
}

const MatierePanel: React.FunctionComponent = (props) => (
    <div>
        {props.matiere_id=="1" ? <Card>Physique</Card>: <div></div>}
        {props.matiere_id=="1" ?<Card>Chimie</Card>: <div></div>}
        {props.matiere_id=="2" ?<Card>Français</Card>: <div></div>}
        {props.matiere_id=="3" ?<Card>Mathématiques</Card>: <div></div>}
        {props.matiere_id=="4" ?<Card>Anglais</Card>: <div></div>}
    </div>
);



